import axiosInstance from "./axiosInstance";

const signIn = (loginCredentials) =>
  axiosInstance.post("/auth/sign_in", loginCredentials);

const signOut = () => axiosInstance.delete("/auth/sign_out");

const register = (userData) => axiosInstance.post("/auth", userData);

const validateToken = () => axiosInstance.get("/auth/validate_token");

const invite = (inviteeData) => axiosInstance.post("/invite", inviteeData);

const updateUser = (userData) => axiosInstance.put("/auth", userData);

const requestPasswordReset = (email) =>
  axiosInstance.post("/auth/password", {
    email,
    redirectUrl: `${window.location.origin}/reset-password`,
  });

const resetPassword = ({ password, passwordConfirmation, resetPasswordToken }) =>
  axiosInstance.put("/auth/password", {
    password,
    passwordConfirmation,
    resetPasswordToken,
  });

export {
  signIn,
  signOut,
  register,
  invite,
  validateToken,
  updateUser,
  requestPasswordReset,
  resetPassword,
};
